import { Injectable } from '@angular/core'

@Injectable({providedIn: 'root'})
export class LeftNavDomService {

  constructor() {
    // noop
  }

  public closestAttr(element: HTMLElement, attr: string): string {
    if (!element) return undefined
    return element.getAttribute && element.getAttribute(attr) || this.closestAttr(element.parentElement, attr) || undefined
  }

}
